export class CategoryAnalytics {
    topCategories;
    constructor(topCategories) {
        this.topCategories = topCategories;
    }
}
